import { render, staticRenderFns } from "./SectionNosotros3.vue?vue&type=template&id=6c3068eb&scoped=true&"
import script from "./SectionNosotros3.vue?vue&type=script&lang=js&"
export * from "./SectionNosotros3.vue?vue&type=script&lang=js&"
import style0 from "./SectionNosotros3.vue?vue&type=style&index=0&id=6c3068eb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3068eb",
  null
  
)

export default component.exports